module.exports = __webpack_public_path__ + "img/elha-logo-green-white.afda481c.svg";